import styled from '@emotion/styled';

export const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;
